import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {
  OligoAwareFolderItemType,
  TagSchemaSupportedFolderItemType,
} from 'graphql-client/__generated/graphqlGlobalTypes';

const MODEL_TYPE_CONSTANTS_SET = new Set(Object.values(ModelTypeConstants));
const OLIGO_AWARE_FOLDER_ITEM_TYPE_SET = new Set(Object.values(OligoAwareFolderItemType));

export function toModelTypeConstant(type: TagSchemaSupportedFolderItemType): ModelTypeConstants {
  const convertedType = type as unknown as ModelTypeConstants;
  assert(MODEL_TYPE_CONSTANTS_SET.has(convertedType), `Type ${type} is not a valid ModelTypeConstants`);
  return convertedType;
}

export function toOligoAwareFolderItemTypeGraphQL(type: ModelTypeConstants): OligoAwareFolderItemType {
  const convertedType = type as unknown as OligoAwareFolderItemType;
  assert(
    OLIGO_AWARE_FOLDER_ITEM_TYPE_SET.has(convertedType),
    `Type ${type} is not a valid OligoAwareFolderItemType`
  );
  return convertedType;
}
